import {CS_SEND_STATUS} from './constants'
import type {CbCsHomepageData, CsEngagedUser} from './reducers'

/** 本地预览开关；联调真实接口时改为 false */
export const USE_MOCK_CB_CS_HOMEPAGE = false

const MOCK_AVATAR = 'https://img01.mehiya.com/img/png/id/432604807202'

const mockUser = (
  patch: Partial<CsEngagedUser> & Pick<CsEngagedUser, 'mid' | 'name'>
): CsEngagedUser => ({
  avatar: MOCK_AVATAR,
  level_icon_url: '',
  online: true,
  unread_count: 0,
  send_status: CS_SEND_STATUS.CAN_SEND,
  level_desc: 'Level 12, 4 upgrades done, need 30k for next.',
  note: 'Note: Guidance rewards required.',
  ...patch,
})

export const MOCK_CB_CS_HOMEPAGE: CbCsHomepageData = {
  err_msg: '',
  total_unread_count: 8,
  current_user: mockUser({
    mid: 10001,
    name: 'Alara · Current',
    unread_count: 0,
    send_status: CS_SEND_STATUS.CAN_SEND,
  }),
  list: [
    mockUser({
      mid: 10002,
      name: 'Alara · Current',
      unread_count: 6,
      online: true,
    }),
    mockUser({
      mid: 10003,
      name: 'Nour',
      unread_count: 0,
      online: false,
      send_status: CS_SEND_STATUS.SENT,
      level_desc: 'Level 8, 2 upgrades done, need 12k for next.',
      note: 'Note: Follow-up gift pending.',
    }),
    mockUser({
      mid: 10004,
      name: 'Maya',
      unread_count: 12,
      online: true,
      level_desc: 'Level 15, 6 upgrades done, need 50k for next.',
      note: '',
    }),
  ],
}
